import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ot-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  @Input() public title;
  @Input() public text;
  @Input() public type = 'confirm';
  @Input() public confirmButtonText = 'Confirm';
  @Input() public cancelButtonText = 'Cancel';

  constructor(public activeModal: NgbActiveModal) {}
}
